// views/Dashboard/PainelExecutivo/components/SeletorBaseData.tsx
import React from 'react';
import { ROTULOS_BASE_DATA, DESCRICOES_BASE_DATA } from '../../../../src/lib/dashboard/filtrarFaturasPorPeriodo';
import type { BaseDataFinanceiro } from '../types';
import InfoTip from '../../../../src/components/InfoTip';

const BASES: BaseDataFinanceiro[] = ['referencia', 'vencimento', 'emissao'];

/**
 * Qual data da fatura o período recorta no Financeiro.
 *
 * A mesma fatura muda de mês conforme a base — competência AGO, emitida em
 * 28/08 e vencendo em 10/09 é o caso de 68% da carteira —, então o rótulo fica
 * visível na barra, nunca escondido num menu.
 */
const SeletorBaseData: React.FC<{
  valor: BaseDataFinanceiro;
  onChange: (v: BaseDataFinanceiro) => void;
}> = ({ valor, onChange }) => (
  <div className="flex items-center gap-2">
    <span className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Data por</span>
    <div className="flex items-center gap-1 rounded-full bg-gray-100 dark:bg-gray-800 p-1">
      {BASES.map((b) => (
        <button
          key={b}
          type="button"
          onClick={() => onChange(b)}
          aria-pressed={valor === b}
          title={DESCRICOES_BASE_DATA[b]}
          className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
            valor === b ? 'bg-primary text-white' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'
          }`}
        >
          {ROTULOS_BASE_DATA[b].replace('Mês de ', '').replace('Mês de', '')}
        </button>
      ))}
    </div>
    <InfoTip label="O que muda entre as três bases">
      <p>
        A mesma fatura cai em meses diferentes: a competência AGO/2026 costuma ser emitida em agosto e vencer em
        setembro. <strong>Referência</strong> é o mês do consumo, <strong>vencimento</strong> é quando o dinheiro
        entra e <strong>emissão</strong> é quando o boleto saiu.
      </p>
      <p className="mt-1">
        Na emissão, 1,5% das faturas não têm a data gravada e ficam de fora do recorte. Os gráficos de evolução
        continuam agrupados por mês de referência.
      </p>
    </InfoTip>
  </div>
);

export default SeletorBaseData;
